<template>
  <div class="payment-receipt-info">
    <h2>Payment receipt</h2>
    <div class="payment-items">
      <div>
        <div>Customer ID</div>
        <div class="desc">
          <p v-if="!isBusinessUser">{{ personalInfo?.personalInformation?.cid || '' }}</p>
          <p v-else>{{ businessInfo?.businessPersonalInformation?.cid || '' }}</p>
        </div>
      </div>
      <div>
        <div>Name on Card</div>
        <div class="desc">
          <p>{{ paymentMakerName }}</p>
        </div>
      </div>
      <div>
        <div>Date Paid</div>
        <div class="desc">
          <p>{{ paymentDate }}</p>
        </div>
      </div>
      <div>
        <div>Authorization Number</div>
        <div class="desc">
          <p>{{ authNumber || '' }}</p>
        </div>
      </div>
      <div>
        <div>Total Amount Paid</div>
        <div class="desc">
          <p>{{ totalAmountPaid }}</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { parseISO } from 'date-fns';
import format from 'date-fns/format'
import { toCurrency } from '@/utils/helpers';
import * as COMMONS from '../../store/_commons';

// Vuex store
const store = useStore();

// Computed properties
const personalInfo = computed(() => store.getters[COMMONS.GUEST_PERSONAL_INFO]);
const businessInfo = computed(() => store.getters[COMMONS.BUSINESS_PROFILE_INFO]);
const isBusinessUser = computed(() => store.state.guestLogin.isBusinessUser);

const finalizationCart = computed(() => store.state.guestLogin?.finalizationCart);
const paymentDetails = computed(() => finalizationCart.value?.finalizeCartResponse?.transactionCart?.cartPayment);

const paymentDate = computed(() => {
  const paidDate = paymentDetails.value?.paymentDate;
  if (!paidDate) return '';

  let tempDate = paidDate;
  if (typeof tempDate === 'string') {
    tempDate = parseISO(paidDate);
  }

  return tempDate ? format(tempDate, 'MMMM d, yyyy') : '';
});

const paymentMakerName = computed(() => {
  const firstName = paymentDetails.value?.paymentMakerFirstName || '';
  const lastName = paymentDetails.value?.paymentMakerLastName || '';
  return `${firstName} ${lastName}`.trim();
});

const authNumber = computed(() => paymentDetails.value?.authorizationNumber);

const totalAmountPaid = computed(() => {
  const amount = paymentDetails.value?.totalCartAmount || 0;
  return toCurrency(amount);
});
</script>

<style lang="scss" scoped>
.payment-receipt-info {
  margin: 0.5em 0 1.5em;
  .payment-items {
    border-top: 1px solid var(--ri-gray);
    border-bottom: 1px solid var(--ri-gray);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1em;
    padding: 1em 0;
    margin-top: 1em;
    .desc {
      @extend %font-sans-bold;
    }
  }
  @media print {
    margin: -1em 0 0;
  }
}
.payment-receipt {
  margin: 1rem 0;
  border-bottom: 1px solid gray;

.payment-receipt-title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid gray;
}
.payment-receipt {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem 10%;
    margin: 15px 0px 10px 0px;
    width: 60%;
    min-width: 500px;
    .payment-receipt-details {
      width: 200px;
    }
  }
}

@media only screen and (max-width: 512px) {
  .payment-receipt{
    .payment-receipt { 
      min-width: 0px;
    }
  } 
}
</style>
